import React, {Component} from 'react';
import {
  View,
  Text,
  TextInput,
  ActivityIndicator,
  TouchableOpacity,
  Platform,
  ImageBackground,
  Dimensions,
  Image,
  ScrollView
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import RescanPopup from './rescan_popup';
import ScanTextInput from '../../commons/Inputs/ScanTextInput';
import {connect} from 'react-redux';
import NetInfo from '@react-native-community/netinfo';
import { GetOrderList, UpdateOrderStatus } from '../../actions/orderActions';
import {
  SearchScanpackOrder,
  ImportOrder,
  ImportOrderStatus,
  CheckImportOrderProcess,
  ResetSearchOrderData,
  hideDuplicatePickWarning,
  hideDuplicatePickToast,
  clearOnDemandImportEvent
} from '../../actions/scanpackAction';
import {GetBothSettings, GetGeneralSetting,UserInfo} from '../../actions/userAction';
import {ShowNotification} from '../../actions/menuActions';
import styles from '../../style/scanpack';
import CommonStyles from '../../style/commonStyles';
import PopUpModel from './pop_up_model';
import OnDemandCountdown from './OnDemandCountdown';
import {LinearGradient} from 'expo-linear-gradient';
import {fontFamily} from '../../helpers/fontFamily';
import {FontAwesome} from '@expo/vector-icons';
import moment from 'moment';
import {ScanOrderAlreadyMsg} from '../notification';
import i18n from 'i18n-js';
import InterNetChecks from '../internateConnectionCheck';
import InerternetConnectionAlert from '../internetConnectionAlert';
import notReady from '../../../assets/sounds/not_ready.mp3';
import {ORDER_LIST} from '../../constants';
import _ from 'lodash';
import ProgressBar from '../../commons/progressBar';
import Clipboard from '@react-native-clipboard/clipboard';
import {AssignOrdersButton} from './assignOrdersButton';
import {OptionalZoneAccessButtons} from './OptionalZoneAccessButtons';
// import QuickScanComponent from './QuickScanComponent';
import { fetchUser, SubmitLog } from '../../actions/saveLogAction';
import CamScanner from '../camScanning/CamScanner';
import { Ionicons } from '@expo/vector-icons';
import { SetCameraOpen } from '../../actions/cameraScannerActions';
import { withCameraScanner } from '../../helpers/withCameraScanner';
import { handleOrderReScan } from '../../helpers/scanPackFunctions';
// import { AssignOrdersButton } from './assignOrdersButton';
import CartAssignmentPrompt from '../scanToCart/prompt';
import scanSuccessSound from '../../../assets/sounds/Scann Success_coin_a.mp3';
import scanFailSound from '../../../assets/sounds/scan_fail_shorter.mp3';
import GradientText from '../../commons/GradientText';
import completeSound from '../../../assets/sounds/_order_complete.mp3';
import { saveScanBarcode } from './apiStorage';
import { navigationRef } from '../root_navigation';
import { getCartInProgress } from '../../actions/scanToCartActions';
import ResumePickingPrompt from '../scanToCart/ResumePickingPrompt';
import AssignmentToast from '../scanToCart/CartAssignmentDetailToast';
import CartAssignmentDetails from '../scanToCart/CartAssignmentDetailPrompt';
import { CartOptionalZoneAccessModal } from './CartOptionalZoneAccessModal';
import { setZoneAccessModalForCart } from '../../actions/scanToCartActions';
import axios from 'axios';
import ShipmentSelectionModal from './shipment_selection_modal';
import DuplicatePickWarningModal from '../scanToCart/DuplicatePickWarningModal';
import Toast from '../../commons/Toast';

global.chatActive = false;
const height = Dimensions.get('window').height;
let orderListSuccess = false;
let searchOrderSuccess = false;
let validateUser = false;
let messageShow = false;
let scannedAlert = false;
let importDates = false;
let attempts = 0;
var notReadySound = new Audio(notReady);
let isToFocus = true;
class ScanPack extends Component {
  constructor(props) {
    super(props);
    this.lastShownImportTimestamp = null;
    this.progressInterval = null;
    this.sawImportRunning = false;
    this.state = {
      orderStatusApiCall: true,
      showProgressBar: false,
      importOrderIntiated: '',
      checkStatusButtonSecondCount: 5,
      isConnected : null,
      windowwidth: 0,
      reScanPopupCond: '',
      toolTipVisible: false,
      data: {
        input: '',
        state: 'scanpack.rfo',
        id: null,
        box_id: null,
        store_order_id: null,
        app: 'app'
      },
      popUpModelShow: false,
      reScanPopupShow: false,
      reScanOrderPopupShow: false,
      dataList: {
        filter: '',
        order: 'DESC',
        limit: '1',
        offset: '0',
        app: 'app',
        count: 0
      },
      orderDetail: null,
      rfoTitle: i18n.t("scanPack.rfoTitle"),
      time: new Date(),
      loading: false,
      newLoading: false,
      loaderTitle: '',
      userInfo: '',
      scan_pack_settings: null,
      quickScanToolTip: false,
      refreshToolTip: false,
      toolTipCheck: false,
      importOrderText: '',
      animatingType: false,
      onDemandCountdown: null,
      onDemandMessage: '',
      onDemandOrderNo: null,
      lastOnDemandEventAt: null,
      cueOrderStatus: '',
      importButton: true,
      EtaText: '',
      ShowEtaText: false,
      showQuick: false,
      quickValue: '',
      showStatus: true,
      orderNumberInput: '',
      popInternet: true,
      // closeModelQz: false,
      cartId: '',
      showCartAssignmentPrompt: false,
      awaitingOrdersCount: 0,
      scannedOrdersCount: 0,
      awaitingOrdersLoading: false,
      scannedOrdersLoading: false,
      showShipmentSelection: false,
      currentOrderData: null,
      currentShipments: null,
      wasScanning: false,
    };
    this.inputFocus = React.createRef();
    this.searchOrder = this.searchOrder.bind(this);
    this.wasShowingCameraBeforeNav = false; // Track if camera was open when navigating away
    this._unsubscribeBlur = null;
    this._cameraPermissionChecker = null; // Parent-level iOS permission revocation safety net
    window.addEventListener('resize', this.update);
    // importDate = true
  }
  componentDidMount() {
    // this.setState({closeModelQz:this.props.route.params.alert})

    // setTimeout(()=>{

    //   this.setState({closeModelQz:!this.props.route.params.alert})
    // },2000)
    this.props.route.params.socketFun();
    this.props.UserInfo();
    this.props.GetBothSettings()
    this.unsubscribe = NetInfo.addEventListener((state) => {
      this.setState({ isConnected: state.isConnected });
    });

          if(!localStorage.getItem('correctScanLabel')){
            localStorage.setItem('correctScanLabel', 'Default Sound')
            localStorage.setItem('correctScanType', scanSuccessSound )
          }
          if(!localStorage.getItem('errorScanLabel')){
            localStorage.setItem('errorScanLabel', 'Default Sound')
            localStorage.setItem('errorScanType', scanFailSound )
          }
          if(!localStorage.getItem('orderScanLabel')){
            localStorage.setItem('orderScanLabel', 'Default Sound')
            localStorage.setItem('orderScanType', completeSound )
          }
    this.props.GetGeneralSetting(this.getCartInProgress);
    this.props.ImportOrderStatus();
    this.setState({loading: true, loaderTitle: 'Loading...'});
    this.getOldestUnscannedOrder();
    validateUser = true;
    this.update();
    
    const sI = setInterval(() => {
      this.test();
    }, 2000);
    if (this.props.showNotification) {
      this.alertBox(
        this.props.isCodeFound
          ? i18n.t('scanpackItem.service_Issue_notification_one')
          : i18n.t('scanpackItem.service_Issue_notification'),
        true,
        true
      );
    }
    notReadySound.load();
    if (global.progressBarValue > 1) {
      this.setState({isImportCompleted: true});
      global.importButton = false;
    }
    if (this.props.route?.params?.page === 'orderSearchList') {
      const orderNumber = this.props.route.params.orderNumber;
      this.searchOrder(orderNumber)
    }
    this._unsubscribe = this.props.navigation?.addListener('focus', this.getCartInProgress);
    this._unsubscribe = this.props.navigation?.addListener('focus', this.handleScreenReturn);
    this._unsubscribeBlur = this.props.navigation?.addListener('blur', this.handleScreenBlur);

    if (Platform.OS === 'web') {
      this._cameraPermissionChecker = async () => {
        if (document.visibilityState !== 'visible') return;
        if (!this.props.cameraHook.showCameraScanner) return;
        try {
          const permStatus = await navigator.permissions?.query?.({ name: 'camera' });
          if (permStatus && permStatus.state === 'denied') {
            console.log('[ScanPack] Parent permission checker: camera denied, closing scanner');
            this.props.cameraHook.closeCamera();
          }
        } catch (e) {}
      };
      document.addEventListener('visibilitychange', this._cameraPermissionChecker);
      window.addEventListener('pageshow', this._cameraPermissionChecker);
    }
  }

  getCartInProgress =()=>{
    let isScanToCartEnabled =
      this.props.scanPackWorkflow === 'scan_to_cart' &&
      this.props.scanToCartOption;
    if (isScanToCartEnabled) {
      this.props.getCartInProgress();
    }
  }
  handleOnDemandImportEvent = event => {
    if (!event || event.receivedAt === this.state.lastOnDemandEventAt) return;

    this.setState({lastOnDemandEventAt: event.receivedAt});

    const waitingOnOrderScan =
      this.state.data?.state === 'scanpack.rfo' && !this.state.data?.id;

    if (waitingOnOrderScan) {
      if (event.kind === 'ready' && event.orderNo) {
        this.startOnDemandCountdown(event.orderNo, event.message);
      } else if (event.message) {
        this.alertBox(event.message, true, true);
      }
    }
    this.props.clearOnDemandImportEvent();
  };

  startOnDemandCountdown = (orderNo, message) => {
    this.clearOnDemandTimer();
    this.setState({
      onDemandCountdown: 3,
      onDemandMessage: message,
      onDemandOrderNo: orderNo
    });

    this.onDemandInterval = setInterval(() => {
      const remaining = this.state.onDemandCountdown - 1;
      if (remaining > 0) {
        this.setState({onDemandCountdown: remaining});
        return;
      }
      this.cancelOnDemandCountdown();
      this.searchOrder(orderNo);
    }, 1000);
  };

  clearOnDemandTimer = () => {
    if (this.onDemandInterval) {
      clearInterval(this.onDemandInterval);
      this.onDemandInterval = null;
    }
  };

  cancelOnDemandCountdown = () => {
    this.clearOnDemandTimer();
    if (this.state.onDemandCountdown !== null) {
      this.setState({
        onDemandCountdown: null,
        onDemandMessage: '',
        onDemandOrderNo: null
      });
    }
  };

  handleScreenBlur = () => {
    this.cancelOnDemandCountdown();
    if (this.props.cameraHook.showCameraScanner) {
      console.log('[ScanPack] Screen blurred with camera open — unmounting CamScanner temporarily to release hardware');
      this.wasShowingCameraBeforeNav = true;
      this.props.cameraHook.setShowCameraScanner(false);
    }
  };

  handleScreenReturn = () => {
    this.setState({ manageApiStatus: true });
    this.props.cameraHook.fetchCamSetting().then(enabled => {
      if (!enabled && this.props.cameraHook.showCameraScanner) {
        this.props.cameraHook.setShowCameraScanner(false);
        this.props.cameraHook.cameraManuallyClosedRef.current = true;
      } else if (this.wasShowingCameraBeforeNav && enabled) {
        console.log('[ScanPack] Restoring camera on focus return');
        this.wasShowingCameraBeforeNav = false;
        this.props.cameraHook.cameraManuallyClosedRef.current = false;
        this.props.cameraHook.setShowCameraScanner(true);
        this.props.SetCameraOpen('scanpack');
      }
    }).catch(e => console.error(e));
  }

  update = () => {
    this.setState({
      windowwidth: window.innerWidth
    });
  };
  //According to the platform call the function
  getOrder = () => {
    if (Platform.OS === 'ios' || Platform.OS === 'android') {
      this.checkConnection('apiCall');
    } else {
      this.apiCall();
    }
  };
  /////////////Alert DialogBox open
  alertBox = (message, skip, messageTypeSuccess) => {
    // console.log("---000msg--", message)
    if (messageTypeSuccess === true) {
      this.setState({
        popUpModelShow: true,
        message: message,
        messageTypeSuccess: true
      });
    } else {
      let checkStatus =
        this.props?.searchOrder?.searchOrder?.data?.order[0]?.order_info
          ?.status;
      if (checkStatus === 'scanned') {
        this.setState({message: message, reScanPopupShow: true});
      }
    }
    setTimeout(
      function () {
        this.setState({
          popUpModelShow: false,
          message: '',
          messageTypeSuccess: false
        });
        this.props.ShowNotification({value: false, codeFound: false});
      }.bind(this),
      4000
    );
  };
  //Check the connection for the ios and android
  checkConnection = async (type, input) => {
    const connectionInfo = await NetInfo.fetch();
    if (connectionInfo.isConnected) {
      type === 'callShipmentOrder'
        ? this.callShipmentOrder(input)
        : this.apiCall();
    } else {
      this.setState({ rfoTitle: i18n.t("scanPack.checkInternet") });
    }
  };
  //Call the api to fetch the data from backend
  apiCall = () => {
    let dataList = _.cloneDeep(this.state.dataList);
    dataList.oldestUnscanned = true;
    dataList.sort = 'order_date';
    dataList.order = 'ASC';
    setTimeout(() => {
      this.props.GetOrderList(dataList);
      orderListSuccess = true;
    }, 3000);
  };

  getOldestUnscannedOrder = () => {
    let dataList = _.cloneDeep(this.state.dataList);
    dataList.oldestUnscanned = true;
    dataList.sort = 'order_date';
    dataList.order = 'ASC';
    setTimeout(() => {
      this.props.GetOrderList(dataList);
      orderListSuccess = true;
    }, 3000);
  };

  checkEstimateFun = data => {
    const estimatedTime = i18n.t("scanPack.estimatedTime");
    const hoursForStore = i18n.t("scanPack.hoursForStore");
    const minutesForStore = i18n.t("scanPack.minutesForStore");
    const secondsForStore = i18n.t("scanPack.secondsForStore");
    const hoursLabel = i18n.t("scanPack.hours");
    const minutesLabel = i18n.t("scanPack.minutes");
    data.import_items.map(estimate => {
      // console.log("estimate", estimate)
      if (estimate.progress !== null && estimate.progress.status !== false) {
        let storeName = estimate?.store_info?.name;
        if (estimate?.progress?.elapsed_time_remaining) {
          if (
            estimate?.progress?.elapsed_time_remaining.substring(0, 2) ==
              '00' &&
            estimate?.progress?.elapsed_time_remaining.substring(3, 5) ==
              '00' &&
            estimate?.progress?.elapsed_time_remaining.substring(6, 8) != '00'
          ) {
            this.setState({
              EtaText: `${estimatedTime}: ${estimate?.progress?.elapsed_time_remaining.substring(
                6,
                8
              )} ${secondsForStore} ${storeName}`
            });
          }
          if (
            estimate?.progress?.elapsed_time_remaining.substring(0, 2) ==
              '00' &&
            estimate?.progress?.elapsed_time_remaining.substring(3, 5) !=
              '00' &&
            estimate?.progress?.elapsed_time_remaining.substring(6, 8) != '00'
          ) {
            this.setState({
              EtaText: `${estimatedTime}: ${estimate?.progress?.elapsed_time_remaining.substring(
                3,
                5
              )} ${minutesLabel} ${estimate?.progress?.elapsed_time_remaining.substring(
                6,
                8
              )} ${secondsForStore} ${storeName}`
            });
          }
          if (
            estimate?.progress?.elapsed_time_remaining.substring(0, 2) ==
              '00' &&
            estimate?.progress?.elapsed_time_remaining.substring(3, 5) !=
              '00' &&
            estimate?.progress?.elapsed_time_remaining.substring(6, 8) == '00'
          ) {
            this.setState({
              EtaText: `${estimatedTime}: ${estimate?.progress?.elapsed_time_remaining.substring(
                3,
                5
              )} ${minutesForStore} ${storeName}`
            });
          }
          if (
            estimate?.progress?.elapsed_time_remaining.substring(0, 2) !==
              '00' &&
            estimate?.progress?.elapsed_time_remaining.substring(3, 5) ==
              '00' &&
            estimate?.progress?.elapsed_time_remaining.substring(6, 8) == '00'
          ) {
            this.setState({
              EtaText: `${estimatedTime}: ${estimate?.progress?.elapsed_time_remaining.substring(
                0,
                2
              )} ${hoursForStore} ${storeName}`
            });
          }
          if (
            estimate?.progress?.elapsed_time_remaining.substring(0, 2) !==
              '00' &&
            estimate?.progress?.elapsed_time_remaining.substring(3, 5) !=
              '00' &&
            estimate?.progress?.elapsed_time_remaining.substring(6, 8) == '00'
          ) {
            this.setState({
              EtaText: `${estimatedTime}: ${estimate?.progress?.elapsed_time_remaining.substring(
                0,
                2
              )} ${hoursLabel} ${estimate?.progress?.elapsed_time_remaining.substring(
                3,
                5
              )} ${minutesForStore} ${storeName}`
            });
          }
          this.setState({ShowEtaText: true});
        } else {
          this.setState({ EtaText: i18n.t("scanPack.calculateEstimate") });
          this.setState({ ShowEtaText: true });
        }
      }
    });
  };
  unauth = async () => {
    try {
      const username = await AsyncStorage.getItem('username');
      const tenent = await AsyncStorage.getItem('tenent');
      await AsyncStorage.clear();
      if (username) {
        await AsyncStorage.setItem('username', username);
      }
      await AsyncStorage.setItem('tenent', tenent ? tenent.toLowerCase() : tenent);
      // this.redirect("SignIn");

      // Reload Window to Fix issues with Socket
      window.location.reload();

      this.props.navigation.navigate('SignIn', {
        api: 'importstatus',
        status: '401'
      });
    } catch (e) {}
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.showDuplicatePickToast && !this.props.showDuplicatePickToast) {
      setTimeout(() => {
        this.props.hideDuplicatePickToast();
      }, 3000);
    }

    this.handleOnDemandImportEvent(nextProps.onDemandImport);

    if (
      nextProps?.importOrder?.importstatusError == '401' ||
      nextProps?.importOrder?.importdataError == '401' ||
      nextProps?.userInfo == '401' ||
      nextProps?.ordersList == '401' ||
      nextProps?.searchOrder.searchOrder == '401'
    ) {
      this.unauth();
    }

    // Sync global.importStores from Redux data when page loads/refreshes
    if (nextProps?.importOrder?.importstatusData?.summary?.import_items) {
      const importItems = nextProps.importOrder.importstatusData.summary.import_items;
      const summaryStatus = nextProps.importOrder.importstatusData.summary.import_info?.status;

      const getStatusMessage = (status) => {
        switch (status) {
          case 'not_started': return 'Waiting...';
          case 'fetch_api_response': return 'Receiving API Response';
          case 'in_progress': return 'Importing Orders';
          case 'completed': return 'Completed';
          case 'failed': return 'Failed';
          case 'cancelled': return 'Cancelled';
          default: return status;
        }
      };

      if (summaryStatus === 'in_progress' || summaryStatus === 'fetch_api_response') {
        this.sawImportRunning = true;
      }

      if ((summaryStatus === 'in_progress' || summaryStatus === 'fetch_api_response') &&
          (!global.importStores || global.importStores.length === 0) &&
          !this.state.importInitializing) {

        const syncedStores = importItems
          .filter(item => {
            const storeStatus = item.store_info?.status;
            return storeStatus === '1' || storeStatus === 1 || storeStatus === true;
          })
          .map(item => ({
            storeName: item.store_info?.name || 'Unknown Store',
            storeId: item.store_info?.id || 0,
            status: item.import_info?.status || 'not_started',
            successImported: item.import_info?.success_imported || 0,
            updatedImported: item.import_info?.updated_orders_import || 0,
            toImport: item.import_info?.to_import || 0,
            message: getStatusMessage(item.import_info?.status || 'not_started'),
            currentIncrementId: item.import_info?.current_increment_id || '',
            startTime: item.import_info?.created_at || null,
            elapsedTimeRemaining: item.progress?.elapsed_time_remaining || null,
            progressStatus: item.progress?.status || null
          }));

        if (syncedStores.length > 0) {
          console.log('Syncing global.importStores from Redux data:', syncedStores);
          global.importStores = syncedStores;
          global.globalImportOrderStatus = summaryStatus;
        }
      }

      // Populate global.lastImportResults when import completes
      if (summaryStatus === 'completed' && !this.state.importInitializing) {
        const completedStores = importItems
          .filter(item => {
            const storeStatus = item.store_info?.status;
            return storeStatus === '1' || storeStatus === 1 || storeStatus === true;
          })
          .map(item => ({
            storeName: item.store_info?.name || 'Unknown Store',
            storeId: item.store_info?.id || 0,
            status: item.import_info?.status || 'completed',
            successImported: item.import_info?.success_imported || 0,
            updatedImported: item.import_info?.updated_orders_import || 0,
            toImport: item.import_info?.to_import || 0,
            message: getStatusMessage(item.import_info?.status || 'completed'),
            currentIncrementId: item.import_info?.current_increment_id || '',
            startTime: item.import_info?.created_at || null,
            elapsedTimeRemaining: item.progress?.elapsed_time_remaining || null,
            progressStatus: item.progress?.status || null
          }));

        if (completedStores.length > 0) {
          const summaryImportInfo =
            nextProps.importOrder.importstatusData.summary.import_info;
          global.lastImportResults = {
            timestamp:
              summaryImportInfo?.updated_at ||
              summaryImportInfo?.created_at ||
              null,
            stores: completedStores
          };
          global.globalImportOrderStatus = 'completed';
          global.importStores = completedStores;
        }
      }
    }

    // Don't process old import status when initializing a new import
    if ((this.state.checkImportStatus == true || this.state.showStatus) && !this.state.importInitializing) {
      if (
        nextProps?.importOrder?.importstatusData?.summary?.import_info
          ?.status == 'cancelled' ||
        nextProps?.importOrder?.importstatusData?.summary?.import_info
          ?.status == 'completed'
      ) {
        this.stopProgressAnimation();
        this.setState({
          importInitializing: false,
          showProgressBar: false,
          importInProgress: false
        });

        if (nextProps?.importOrder?.importstatusData?.summary?.import_info?.status == 'completed' &&
            global.lastImportResults &&
            this.sawImportRunning &&
            !this.state.showCompletionSummary) {
          this.setState({ showCompletionSummary: true });
        }
        if (
          nextProps.importOrder.importstatusData?.summary?.import_info
            ?.updated_at
        ) {
          const lastImport = i18n.t("scanPack.lastImportLabel");
          const agoLabel = i18n.t("scanPack.ago");
          this.setState({ ShowEtaText: false });
          let currentdate = new Date();
          // console.log(moment(currentdate).format('mm'))
          let updatedate = new Date(
            nextProps.importOrder.importstatusData?.summary?.import_info?.updated_at
          );
          // console.log(updatedate.getMonth())
          let status =
            nextProps?.importOrder?.importstatusData?.summary?.import_info
              ?.status;

          if (currentdate.getFullYear() !== updatedate.getFullYear()) {
            let days = currentdate - updatedate;
            // console.log("----days by update date", (days / (1000 * 60 * 60 * 24)).toFixed(0))
            let d = (days / (1000 * 60 * 60 * 24)).toFixed(0);
            let daycheck = d == 1 ? `${d} day` : `${d} days`;
            this.setState({ importOrderText: `${lastImport} ${status} ${daycheck} ${agoLabel}` });
          }
          if (
            currentdate.getFullYear() == updatedate.getFullYear() &&
            currentdate.getMonth() == updatedate.getMonth() &&
            currentdate.getDay() !== updatedate.getDay()
          ) {
            let days = currentdate - updatedate;
            let d = (days / (1000 * 60 * 60 * 24)).toFixed(0);
            let daycheck = d == 1 ? `${d} day` : `${d} days`;
            this.setState({ importOrderText: `${lastImport} ${status} ${daycheck} ${agoLabel}` });
          }
          if (
            currentdate.getFullYear() == updatedate.getFullYear() &&
            currentdate.getMonth() !== updatedate.getMonth()
          ) {
            let month = currentdate.getMonth() - updatedate.getMonth();
            let monthcheck = month == 1 ? `${month} month` : `${month} months`;
            this.setState({ importOrderText: `${lastImport} ${status} ${monthcheck} ${agoLabel}` });
          }
          if (
            currentdate.getFullYear() == updatedate.getFullYear() &&
            currentdate.getMonth() == updatedate.getMonth() &&
            currentdate.getDay() == updatedate.getDay() &&
            currentdate.getHours() !== updatedate.getHours()
          ) {
            let hour =
              moment(currentdate).format('HH') -
              moment(updatedate).format('HH');
            let min =
              moment(currentdate).format('mm') -
              moment(updatedate).format('mm');
            if (min.toString().includes('-')) {
              hour = hour - 1;
              let minc = 60 - parseInt(moment(updatedate).format('mm'));
              let ss = parseInt(moment(currentdate).format('mm')) + minc;
              min = ss;
            }
            let hourCheck =
              hour == 0 ? '' : hour == 1 ? `${hour} hour` : `${hour} hours`;
            let minCheck =
              min == '0' ? '' : min == 1 ? `${min} minute` : `${min} minutes`;
            this.setState({
              importOrderText: `${lastImport} ${status} ${hourCheck} ${minCheck} ${agoLabel}`
            });
          }
          if (
            currentdate.getFullYear() == updatedate.getFullYear() &&
            currentdate.getMonth() == updatedate.getMonth() &&
            currentdate.getDay() == updatedate.getDay() &&
            currentdate.getHours() == updatedate.getHours() &&
            currentdate.getMinutes() !== updatedate.getMinutes()
          ) {
            let minut =
              moment(currentdate).format('mm') -
              moment(updatedate).format('mm');
            let minut1 = moment(currentdate).format('m:ss');
            let min2 = moment(updatedate).format('m:ss');
            let sec =
              moment(currentdate).format('ss') -
              moment(updatedate).format('ss');
            if (sec.toString().includes('-')) {
              minut = minut - 1;
              let se = 60 - parseInt(moment(updatedate).format('ss'));
              let ss = parseInt(moment(currentdate).format('ss')) + se;
              sec = ss;
            }
            let minCheck =
              minut == 0
                ? ''
                : minut == 1
                ? `${minut} minute`
                : `${minut} minutes`;
            let secCheck =
              sec == '0' ? '' : sec == 1 ? `${sec} second` : `${sec} seconds`;
            this.setState({
              importOrderText: `${lastImport} ${status} ${minCheck} ${secCheck} ${agoLabel}`
            });
            // console.log("----days by update date", minut)
          }
          if (
            currentdate.getFullYear() == updatedate.getFullYear() &&
            currentdate.getMonth() == updatedate.getMonth() &&
            currentdate.getDay() == updatedate.getDay() &&
            currentdate.getHours() == updatedate.getHours() &&
            currentdate.getMinutes() == updatedate.getMinutes() &&
            currentdate.getSeconds() !== updatedate.getSeconds()
          ) {
            // let minut = moment(currentdate).format('mm') - moment(updatedate).format('mm')
            let sec =
              moment(currentdate).format('ss') -
              moment(updatedate).format('ss');
            let secCheck = sec == 1 ? `${sec} second` : ` ${sec} seconds`;
            this.setState({ importOrderText: `${lastImport} ${status} ${secCheck} ${agoLabel}` });
          }
        }
        this.setState({
          animatingType: false,
          importButton: true
        });
      }
      if (
        nextProps?.importOrder?.importstatusData?.summary?.import_info
          ?.status == 'in_progress'
      ) {
        this.setState({importButton: false});
        this.checkEstimateFun(nextProps.importOrder.importstatusData?.summary);
        if (
          nextProps.importOrder.importstatusData?.summary?.import_info
            ?.created_at
        ) {
          let currentdate = new Date();
          // console.log(moment(currentdate).format('h:mm'))
          let createdate = new Date(
            nextProps.importOrder.importstatusData?.summary?.import_info?.created_at
          );
          const agoLabel = i18n.t("scanPack.ago");
          let status = i18n.t("scanPack.importStartedLabel");
          if (currentdate.getFullYear() !== createdate.getFullYear()) {
            let days = currentdate - createdate;
            let d = (days / (1000 * 60 * 60 * 24)).toFixed(0);
            let daycheck = d == 1 ? `${d} day` : `${d} days`;
            this.setState({ importOrderText: `${status} ${daycheck} ${agoLabel}` });
          }
          if (
            currentdate.getFullYear() == createdate.getFullYear() &&
            currentdate.getMonth() == createdate.getMonth() &&
            currentdate.getDay() !== createdate.getDay()
          ) {
            let days = currentdate - createdate;
            let d = (days / (1000 * 60 * 60 * 24)).toFixed(0);
            let daycheck = d == 1 ? `${d} day` : `${d} days`;
            this.setState({ importOrderText: `${status} ${daycheck} ${agoLabel}` });
          }
          if (
            currentdate.getFullYear() == createdate.getFullYear() &&
            currentdate.getMonth() !== createdate.getMonth()
          ) {
            let month = currentdate.getMonth() - createdate.getMonth();
            this.setState({ importOrderText: `${status} ${month} months ${agoLabel}` });
          }
          if (
            currentdate.getFullYear() == createdate.getFullYear() &&
            currentdate.getMonth() == createdate.getMonth() &&
            currentdate.getDay() == createdate.getDay() &&
            currentdate.getHours() !== createdate.getHours()
          ) {
            let hour =
              moment(currentdate).format('H') - moment(createdate).format('H');
            let min =
              moment(currentdate).format('mm') -
              moment(createdate).format('mm');
            if (min.toString().includes('-')) {
              hour = hour - 1;
              let minc = 60 - parseInt(moment(createdate).format('mm'));
              let ss = parseInt(moment(currentdate).format('mm')) + minc;
              min = ss;
            }
            let hourCheck =
              hour == 0 ? '' : hour == 1 ? `${hour} hour` : `${hour} hours`;
            let minCheck =
              min == '0' ? '' : min == 1 ? `${min} minute` : `${min} minutes`;
            this.setState({
              importOrderText: `${status} ${hourCheck} ${minCheck} ${agoLabel}`
            });
          }
          if (
            currentdate.getFullYear() == createdate.getFullYear() &&
            currentdate.getMonth() == createdate.getMonth() &&
            currentdate.getDay() == createdate.getDay() &&
            currentdate.getHours() == createdate.getHours() &&
            currentdate.getMinutes() !== createdate.getMinutes()
          ) {
            let minut =
              moment(currentdate).format('mm') -
              moment(createdate).format('mm');
            let secd =
              moment(currentdate).format('ss') -
              moment(createdate).format('ss');
            if (secd.toString().includes('-')) {
              minut = minut - 1;
              let se = 60 - parseInt(moment(createdate).format('ss'));
              let ss = parseInt(moment(currentdate).format('ss')) + se;
              secd = ss;
            }
            let minCheck =
              minut == 0
                ? ''
                : minut == 1
                ? `${minut} minute`
                : `${minut} minutes`;
            let secCheck =
              secd == '0'
                ? ''
                : secd == 1
                ? `${secd} second`
                : `${secd} seconds`;

            this.setState({
              importOrderText: `${status} ${minCheck} ${secCheck} ${agoLabel}`
            });
          }
          if (
            currentdate.getFullYear() == createdate.getFullYear() &&
            currentdate.getMonth() == createdate.getMonth() &&
            currentdate.getDay() == createdate.getDay() &&
            currentdate.getHours() == createdate.getHours() &&
            currentdate.getMinutes() == createdate.getMinutes() &&
            currentdate.getSeconds() !== createdate.getSeconds()
          ) {
            let sec =
              moment(currentdate).format('ss') -
              moment(createdate).format('ss');
            // console.log("here--->>>sec", sec)
            let secCkeck = sec == 1 ? `${sec} second` : `${sec} seconds`;
            this.setState({ importOrderText: `${status} ${secCkeck} ${agoLabel}` });
          }
        }
      }
      if (
        nextProps?.importOrder?.importstatusData?.summary?.import_info
          ?.status == 'not_started'
      ) {
        global.importButton = false;
      }
    }
  }
  componentDidUpdate(pP, ps) {
    if (pP.isImportActive !== this.props.isImportActive ||
        pP.awaitingCountFromImport !== this.props.awaitingCountFromImport) {
      if (this.props.isImportActive && this.props.awaitingCountFromImport !== null) {
        this.setState({ awaitingOrdersCount: this.props.awaitingCountFromImport });
      }
    }

    const currentStatus = global.globalImportOrderStatus;
    const statusChanged = this.lastGlobalStatus !== currentStatus;
    this.lastGlobalStatus = currentStatus;

    if (currentStatus === 'in_progress' || currentStatus === 'fetch_api_response') {
      this.sawImportRunning = true;
    }

    if (this.state.importInitializing &&
        statusChanged &&
        (currentStatus === 'in_progress' || currentStatus === 'fetch_api_response')) {
      this.setState({ importInitializing: false });
    }
    const currentImportTimestamp = global.lastImportResults?.timestamp;
    const hasNewImport = currentImportTimestamp && currentImportTimestamp !== this.lastShownImportTimestamp;

    if (global.lastImportResults &&
        global.globalImportOrderStatus === 'completed' &&
        !this.state.showCompletionSummary &&
        !this.state.importInitializing &&
        this.sawImportRunning &&
        hasNewImport) {
      this.lastShownImportTimestamp = currentImportTimestamp;
      this.setState({ showCompletionSummary: true });
    }

    // Keep global.importStores in sync with Redux data for elapsed_time_remaining updates
    if (this.props.importOrder?.importstatusData?.summary?.import_items &&
        global.importStores && global.importStores.length > 0 &&
        (currentStatus === 'in_progress' || currentStatus === 'fetch_api_response')) {

      const importItems = this.props.importOrder.importstatusData.summary.import_items;
      let hasUpdates = false;

      // Update elapsed_time_remaining for each store in global.importStores
      const updatedStores = global.importStores.map(store => {
        const matchingItem = importItems.find(item => item.store_info?.id === store.storeId);
        if (matchingItem) {
          const newElapsedTime = matchingItem.progress?.elapsed_time_remaining;
          if (newElapsedTime && newElapsedTime !== store.elapsedTimeRemaining) {
            hasUpdates = true;
          }
          return {
            ...store,
            elapsedTimeRemaining: newElapsedTime || store.elapsedTimeRemaining,
            progressStatus: matchingItem.progress?.status || store.progressStatus,
            successImported: matchingItem.import_info?.success_imported || store.successImported,
            updatedImported: matchingItem.import_info?.updated_orders_import || store.updatedImported,
            status: matchingItem.import_info?.status || store.status
          };
        }
        return store;
      });

      if (hasUpdates) {
        global.importStores = updatedStores;
        // Force re-render by updating state
        this.forceUpdate();
      }
    }

if( (ps.isConnected !== this.state.isConnected) && this.state.isConnected && ps.isConnected !== null){
  if(this.props.searchOrder?.offlineData?.length){
    setTimeout(()=>{
    this.props.SubmitLog(undefined , this.props.searchOrder.offlineData)
    },3000)
  }
}

  // if(navigationRef?.current?.getCurrentRoute()?.name === "ScanPack"){
  //   if(this.props.searchOrder?.offlineData?.length){
  //     debugger
  //       this.props.SubmitLog(undefined , this.props.searchOrder.offlineData)
  //   }
  // localStorage.removeItem('scan_barcode_1')
  // localStorage.removeItem('orders_1')
  // localStorage.removeItem('settings_1')
  // localStorage.removeItem('products_1')
  // }
    // if(importDates == true){
    //   console.log("props scan",this.props.importOrder.importstatusData)
    //   importDates = false
    // }
    if(this.props.orderList?.orderList){
      this.apiCall()
      this.props.fetchUser(false)
    }
    if (
      orderListSuccess === true &&
      this.props &&
      this.props.ordersList &&
      this.props.ordersList !== this.state.list
    ) {
      orderListSuccess = false;
      let list = this.props.ordersList;

      let orderShow = list?.orders?.length === 0 ? true : false;
      this.setState({
        scan_pack_settings: list?.scan_pack_settings,
        general_settings: list?.general_settings,
        rfoTitle:
          list?.orders?.length > 0
            ? list && list?.orders[0] && list?.orders[0]?.ordernum
            : null,
        //rfoTitle: list.orders.length > 0 ? list && list.orders[0] && list.orders[0].ordernum : "Please scan an order to continue." ,
        orderDetail: list && list.orders && list.orders[0],
        loading: false,
        list: this.props.ordersList,
        unClick: orderShow,
        awaitingOrdersCount: list?.orders_count?.awaiting || 0,
        scannedOrdersCount: list?.orders_count?.scannedtoday || 0
      });
      if (list?.scan_pack_settings?.scan_by_packing_slip) {
        this.setState({cueOrderStatus: i18n.t('scanPack.packing_slip')});
      }
      if (list?.scan_pack_settings?.scan_by_packing_slip_or_shipping_label) {
        this.setState({
          cueOrderStatus: i18n.t('scanPack.shippingLable_or_packingSlip')
        });
      }
      if (list?.scan_pack_settings?.scan_by_shipping_label) {
        this.setState({cueOrderStatus: i18n.t('scanPack.shippingLable')});
      }
    }
    if (
      messageShow === false &&
      this.props &&
      this.props.route &&
      this.props.route.params &&
      this.props.route.params.showScannedMessage
    ) {
      const scannedOrder = this.props.route.params.scannedOrder;
      if (scannedOrder?.id) {
        this.setState({reScanPopupCond: scannedOrder, reScanPopupShow: true});
      } else {
        this.alertBox(i18n.t('scanPack.already_scanned'), true, false);
      }
      this.setState({loading: true, loaderTitle: 'Loading...'});
      this.getOrder();
      messageShow = true;
    }
    if (
      messageShow === false &&
      this.props &&
      this.props.route &&
      this.props.route.params &&
      this.props.route.params.showCancelledMessage
    ) {
      this.alertBox(i18n.t('scanPack.already_cancelled'), true, true);
      this.setState({loading: true, loaderTitle: 'Loading...'});
      this.getOrder();
      messageShow = true;
    }

    if (
      scannedAlert === false &&
      this.props &&
      this.props.route &&
      this.props.route.params &&
      this.props.route.params.showScannedMessageAlert
    ) {
      this.alertBox(i18n.t('scanPack.scanned_one_pass'), true, true);
      // this.setState({ loading: true, loaderTitle: "Loading..." })
      // this.getOrder()
      scannedAlert = true;
    }
    //Search Order Data
    if (
      searchOrderSuccess === true &&
      this.props &&
      this.props.searchOrder &&
      this?.props?.searchOrder?.time > this?.state?.apiCallTime &&
      this?.props?.searchOrder !== this?.state?.oldOne
    ) {
      let searchResult =
        this?.props?.searchOrder && this?.props?.searchOrder?.searchOrder;
      let order =
        searchResult &&
        searchResult?.data?.order &&
        searchResult?.data?.order[0];
      if (searchResult) {
        if (searchResult?.matched && searchResult?.error_messages.length === 0) {
          if (searchResult?.data) {
            this.setState({ wasScanning: false });
            if (!order && searchResult?.data?.status === 'scanned') {
              this.showAlreadyScannedPrompt(searchResult.data);
            } else {
              this.orderDetails(order);
            }
            searchOrderSuccess = false;
          } else {
            if (searchResult.data.status === 'scanned') {
              let message = i18n.t("scanPack.alreadyScannedMessage",{orderNumber: searchResult.data.order_num});
              this.statusFunction(message);
              this.setState({unClick: true});
            }
          }
        } else if (searchResult?.on_demand === true) {
          this.alertBox(
            searchResult?.notice_messages?.length
              ? searchResult.notice_messages
              : i18n.t('scanPack.onDemandRequested'),
            true,
            true
          );
          this.setState({unClick: true});
          searchOrderSuccess = false;
          if (this.state.wasScanning) {
            this.props.cameraHook.openCamera();
            this.setState({wasScanning: false});
          }
        } else {
          this.alertBox(searchResult?.error_messages, true, true);
          notReadySound.play();
          this.setState({unClick: true});
          searchOrderSuccess = false;
          if (this.state.wasScanning) {
            this.props.cameraHook.openCamera();
            this.setState({ wasScanning: false });
          }
        }
        this.setFocus();
        let data = this.state.data;
        data['input'] = '';
        this.setState({oldOne: this.props.searchOrder, data, loading: false, manageApiStatus: true});
      }
    }
    if (
      validateUser &&
      this.props &&
      this.props.userInfo &&
      this.props.userInfo !== this.state.userInfo
    ) {
      if (this.props.userInfo.is_active === false) {
        validateUser = false;
        this.props.UserInfo(false);
        this.redirect();
      }
    }

    !this.props.isOpen && isToFocus && !global?.chatActive && this.inputFocus.current.focus();

    // Only focus input if camera scanner is not open
    if (isToFocus && !global.chatActive && this.inputFocus.current && !this.props.cameraHook.showCameraScanner) {
      this.inputFocus.current.focus();
    }
  }
  //////////// For Close Alert
  closeAlert = () => {
    this.setState({popUpModelShow: false});
    this.props.ShowNotification({value: false, codeFound: false});
  };
  closePopup = () => {
    this.setState({reScanPopupShow: false});
  };
  redirectToAnother = () => {
    this.setState({reScanPopupShow: false});
    this.setState({reScanOrderPopupShow: true});
  };
  closePopupRescan = () => {
    this.setState({reScanOrderPopupShow: false});
  };
  awaitOrderDataFun = async parameter => {
    const data = {
      filter: 'all',
      inverted: false,
      limit: 20,
      offset: 0,
      order: 'DESC',
      orderArray: [{id: this.state?.reScanPopupCond?.id}],
      product_search_toggle: 'true',
      reallocate_inventory: false,
      search: '',
      select_all: false,
      sort: '',
      status: 'awaiting',
      pull_inv: parameter,
      on_ex: 'on GPX'
    };
    this.props.ResetSearchOrderData();
    this.props.UpdateOrderStatus(data, this.callBack);
    await AsyncStorage.setItem('statusChange', 'pending')
  };
  setStateCallback = (changes) => {
    this.setState(changes);
  };
  callBack = async (status, message) => {
    if(status === false){
      this.alertBox(message, true, true);
      return;
    }
    handleOrderReScan({
      searchOrder: this.searchOrder,
      orderNumberInput: this.state.orderNumberInput,
      closePopupRescan: this.closePopupRescan,
      setState: this.setStateCallback,
      maxAttempts: 3,
    });
  };

  redirect = async () => {
    // await AsyncStorage.removeItem("access_token")
    await AsyncStorage.clear();
    this.props.navigation.navigate('SignIn', {
      status: 'Inactive',
      time: new Date()
    });
    this.setState({userInfo: this.props.userInfo});
  };
  //After the apis call update the status (scanned , order  not present)
  statusFunction = message => {
    let data = this.state.data;

    data['input'] = '';
    this.setState({rfoTitle: message, data});
  };

  //To set the focus
  setFocus = () => {
    // Only focus input if camera scanner is not open
    if (!this.props.cameraHook.showCameraScanner && this.inputFocus.current) {
      this.inputFocus.current.focus();
    }
  };

  showAlreadyScannedPrompt = data => {
    if (!data?.id) {
      this.alertBox(
        i18n.t('scanPack.alreadyScannedMessage', {orderNumber: data?.order_num}),
        true,
        true
      );
      return;
    }
    this.setState({
      reScanPopupCond: {
        id: data.id,
        increment_id: data?.order_num,
        scanned_on: data?.scanned_on
      },
      reScanPopupShow: true,
      showQuick: false
    });
  };

  //Redirect to the scanpackItem page with order details
  orderDetails = (order) => {
    if (!order || !order?.scan_hash?.data?.order) {
        console.warn("Invalid order data received");
        return;
    }

    const order_data = order.scan_hash.data.order;
    const shipments = order_data?.shipments;

    this.setState({
        reScanPopupCond: this.props?.searchOrder?.searchOrder?.data?.order?.[0] ?? null,
    });

    if (this?.props?.userInfo?.role?.access_scanpack) {
        const hasUnscannedItems = order_data?.unscanned_items?.length > 0;
        const hasScannedItems = order_data?.scanned_items?.length > 0;
        const isScanned = order_data?.status === "scanned";

        if (!hasUnscannedItems && !hasScannedItems && !isScanned) {
            this.alertBox(i18n.t("scanPack.empty_order"), true, true);
            this.setState({ loading: true, loaderTitle: "Loading..." });
            this.getOrder();
            return;
        }

        if (isScanned) {
            this.setState({ reScanPopupShow: true, loading: false, showQuick: false });
            return;
        }

        if (shipments && shipments.length > 1) {
            this.setState({
                showShipmentSelection: true,
                currentOrderData: order_data,
                currentShipments: shipments,
                loading: false,
                showQuick: false,
            });
            return;
        } else if (shipments && shipments.length === 1) {
            const singleShipment = shipments[0];
            this.navigateToScanPackItemWithShipment(order, singleShipment);
            return;
        }

        if (order?.scan_hash?.data) {
            let packingcamPage =
                order_data.increment_id === this?.props?.route?.params?.order_in
                    ? this?.props?.route?.params?.page
                    : "";

            // Reset ssLabelData to avoid previous order's data
            const updatedProps = { ...this.props, ssLabelData: undefined };

            this.setState({ showQuick: false });

            console.log("data", order.scan_hash.data);
            console.log("userdata", updatedProps);

            this.props.navigation.navigate({
                name: "ScanPackItem",
                params: {
                    data: order.scan_hash.data,
                    userdata: updatedProps?.userInfo,
                    packingcamPage,
                    isConnected : this.props.route.params.isConnected
                },
                key: new Date().getTime().toString(), // Forces re-mount
            });
            messageShow = false;
        } else if (order?.order_info?.status === 'scanned') {
            this.setState({ reScanPopupShow: true });
        }
    } else {
      this.alertBox(
        i18n.t('scanPack.permissionDeniedTitle') +
          '\n' +
          i18n.t('scanPack.permissionDeniedMessage'),
        true,
        true
      );
    }
  };
  handleShipmentSelection = (selectedShipment) => {
    const { currentOrderData } = this.state;

    this.setState({ showShipmentSelection: false });

    const orderWrapper = {
      scan_hash: {
        data: {
          order: currentOrderData
        }
      }
    };
    this.navigateToScanPackItemWithShipment(orderWrapper, selectedShipment);
  };

  navigateToScanPackItemWithShipment = (order, shipment) => {
    const orderInfo = order.scan_hash.data.order;

    const ensureChildItems = (items) => {
      return items.map(item => ({
        ...item,
        child_items: item.child_items || []
      }));
    };

    const shipmentOrderData = {
      order: {
        ...orderInfo,
        unscanned_items: ensureChildItems(shipment.unscanned_items || []),
        scanned_items: ensureChildItems(shipment.scanned_items || []),
      }
    };

    let packingcamPage =
    orderInfo.increment_id === this?.props?.route?.params?.order_in? this?.props?.route?.params?.page : '';
    const updatedProps = { ...this.props, ssLabelData: undefined };
    this.setState({ showQuick: false });

    this.props.navigation.navigate({
      name: 'ScanPackItem',
      params: {
        data: shipmentOrderData,
        selectedShipment: shipment,
        shipmentId: shipment.shipment_id,
        incrementID: orderInfo.increment_id,
        userdata: updatedProps?.userInfo,
        packingcamPage,
        isConnected: this.props.route.params.isConnected
      },
      key: new Date().getTime().toString(), // Forces re-mount
    });
  };

  closeShipmentSelection = () => {
    this.setState({
      showShipmentSelection: false,
      currentOrderData: null,
      currentShipments: null,
      loading: false,
    });
  };

  handleCloseDuplicatePickWarning = () => {
    this.props.hideDuplicatePickWarning();
    let data = this.state.data;
    data['input'] = '';
    this.setState({
      data,
      loading: false,
      loaderTitle: ''
    });
  };

  handleContinueDuplicatePick = () => {
    const originalData = this.props.duplicatePickWarningData;
    if (originalData) {
      const rescanData = {
        ...originalData,
        quick_rescan: true
      };
      this.handleCloseDuplicatePickWarning();
      this.props.SearchScanpackOrder(rescanData);
    } else {
      this.handleCloseDuplicatePickWarning();
    }
  };

  handleReportDuplicatePick = () => {
    const originalData = this.props.duplicatePickWarningData;
    if (originalData) {
      const reportData = {
        ...originalData,
        report_double_pick: true
      };
      this.handleCloseDuplicatePickWarning();
      this.props.SearchScanpackOrder(reportData);
    } else {
      this.handleCloseDuplicatePickWarning();
    }
  };

  handleSilenceNotifications = async () => {
    await AsyncStorage.setItem('silenceDuplicatePickWarnings', 'true');

    const originalData = this.props.duplicatePickWarningData;
    if (originalData) {
      const silenceData = {
        ...originalData,
        silence_duplicate_warning: true
      };
      this.handleCloseDuplicatePickWarning();
      this.props.SearchScanpackOrder(silenceData);
    } else {
      this.handleCloseDuplicatePickWarning();
    }
  };

  handleCameraScan = (scannedValue) => {
    if (scannedValue) {
      console.log('[ScanPack] Camera scanned value:', scannedValue);

      let data = this.state.data;
      data['input'] = scannedValue;

      this.setState({ data, wasScanning: true }, () => {
        console.log('[ScanPack] Triggering search from camera scan (camera remains open)');
        this.searchOrder(scannedValue);
      });
    }
  };

  handleCameraClose = () => {
    console.log('[ScanPack] User manually closed camera');
    this.props.cameraHook.closeCamera();
    this.setState({ wasScanning: false });
  };

  openCameraScanner = () => {
    console.log('[ScanPack] User manually opened camera');
    this.props.cameraHook.openCamera();
  };

  searchOrder = input => {
    this.cancelOnDemandCountdown();
    this.setState({
      manageApiStatus: false,
      loading: true,
      loaderTitle: 'Loading...',
      orderNumberInput: input
    });
    if (input !== '') {
      if (Platform.OS === 'ios' || Platform.OS === 'android') {
        this.checkConnection('callShipmentOrder', input);
      } else {
        this.callShipmentOrder(input);
      }
    }
  };
  //Api to call the search order
  callShipmentOrder = input => {
    // console.log("check input here",input)
    let shipmentOrder = this.state.data;
    let isScanToCartEnabled = this.props?.scanPackWorkflow === 'scan_to_cart' && this.props?.scanToCartOption
    shipmentOrder['input'] = input;
    shipmentOrder['scan_to_cart_enabled'] = isScanToCartEnabled;
    if (input !== '') {
      shipmentOrder.input = input;
      this.props.SearchScanpackOrder(shipmentOrder,isScanToCartEnabled ? this.handleCartAssignmentCallBack : undefined).then(async(item)=>{
        await saveScanBarcode(item);
      });
      searchOrderSuccess = true;
      let apiCallTime = new Date();
      this.setState({apiCallTime});
    }
  };

  handleCartAssignmentCallBack = (cartId, message) => {
    const updatedData = {
      ...this.state.data,
      input: ''
    };

    this.setState({
      loading: false,
      manageApiStatus: true,
      data: updatedData,
      ...(cartId && message && {
        cartId,
        showCartAssignmentPrompt: true
      })
    });
  }
  //Handle the search field input
  handleChange = (name, value) => {
    let order = this.state.data;
    if (name === 'searchOrder') {
      order['input'] = value;
    }
    if (this?.props?.userInfo?.role?.import_orders) {
      if (value === 'QUICKSCAN') {
        this.setState({showQuick: true});
        this.callShipmentOrder(this.state.rfoTitle);
      }
    }
    this.setState({order});
  };
  importorderFun = () => {
    this.setState({
      importOrderText:
        'Import starting. Please click refresh in a moment to check status.'
    });
    this.setState({animatingType: true});
    this.setState({showStatus: false});
    this.setState({importButton: false});
    this.props.ImportOrder();
  };
  // importTextFun = (text) =>{
  //   this.setState({importOrderText : text })

  // }
  startProgressAnimation = () => {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }

    this.progressInterval = setInterval(() => {
      this.setState(prevState => {
        let newProgress = prevState.progress + 5;

        if (newProgress >= 90) {
          newProgress = 90;
        }

        global.progressBarValue = newProgress;
        return { progress: newProgress };
      });
    }, 1000);
  };

  stopProgressAnimation = () => {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  };

  componentWillUnmount() {
    this.clearOnDemandTimer();
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.stopProgressAnimation();
    this.props.GetOrderList(this.state.dataList, false);
    this.setState({importOrderText: ''});

    if (this._unsubscribe) {
      this._unsubscribe();
    }
    if (this._unsubscribeBlur) {
      this._unsubscribeBlur();
    }
    if (this._cameraPermissionChecker) {
      document.removeEventListener('visibilitychange', this._cameraPermissionChecker);
      window.removeEventListener('pageshow', this._cameraPermissionChecker);
      this._cameraPermissionChecker = null;
    }
  }
  drawerClose = () => {
    this.props.route.params.closeDrawer();
  };
  refreshStatus = () => {
    this.props.ImportOrderStatus();
    this.setState({showStatus: true, importButton: true});
  };
  tooltipFun = () => {
    this.setState({toolTipCheck: !this.state.toolTipCheck});
    this.setState({quickScanToolTip: !this.state.quickScanToolTip});
  };
  refreshTooltipFun = () => {
    this.setState({refreshToolTip: !this.state.refreshToolTip});
  };
  test = async () => {
    let num = await InterNetChecks();
    if (num !== true) {
      this.setState({popInternet: false});
    } else {
      this.setState({popInternet: true});
    }
  };
  closeRescanPopup = () => {
    this.setState({reScanPopupShow: false});
  };

  handleOrderImport = () => {
    this?.props?.userInfo?.role?.import_orders &&
    this.state.popInternet === true && (
      this.importorderFun()
    )
  }

  navigateToOrders = async (status) => {
    console.log('Navigating to orders with status:', status);

    if (status === 'awaiting') {
      this.setState({ awaitingOrdersLoading: true });
    } else {
      this.setState({ scannedOrdersLoading: true });
    }

    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');

      if (status === 'scanned') {
        const apiUrl = `${url}/orders/get_scanned_today_orders.json?order=DESC&limit=20&sort=&offset=0&app=${true}`;
        const response = await axios({ method: 'get', url: apiUrl, headers: { Authorization: `Bearer ${access_token}`} });

        this.props.navigation.navigate('Orders', {
          initial_status: 'ScannedToday',
          preFilteredData: response.data,
          userInfo: this.props.userInfo,
          fromScanPack: true,
          page: 'orderSearchList',
          isScannedToday: true
        });

        this.setState({ scannedOrdersLoading: false });
        return;
      }

      const filterStatus = 'Awaiting';
      const dateValue = ''; // Changed from '14' to '' to get all awaiting orders without date filter
      const dateRange = {"start_date": "", "end_date": ""};
      const dateRangeString = encodeURIComponent(JSON.stringify(dateRange));
      const timestamp = Date.now();

      const filters = [
        { name: 'Status', operator: 'eq', type: 'string', value: [filterStatus] }
      ];
      const filtersString = JSON.stringify(filters);

      const apiUrl = `${url}/orders/sorted_and_filtered_data.json?filter=${filterStatus}&order=DESC&limit=20&sort=&offset=0&app=${true}&count=&dateValue=${dateValue}&dateRange=${dateRangeString}&filters=${filtersString}&match_option=Any&search=&filterIncludedTags=undefined&tags_name=&username=&_t=${timestamp}`;
      const response = await axios({
        method: 'get',
        url: apiUrl,
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      });

      this.props.navigation.navigate('Orders', {
        initial_status: filterStatus,
        preFilteredData: response.data,
        userInfo: this.props.userInfo,
        fromScanPack: true,
        page: 'orderSearchList',
        dateFilter: 'all_day'
      });

      this.setState({ awaitingOrdersLoading: false });

    } catch (error) {
      console.error('Error filtering orders:', error);
      this.props.navigation.navigate('Orders', {
        initial_status: status === 'awaiting' ? 'Awaiting' : 'ScannedToday',
        userInfo: this.props.userInfo,
        fromScanPack: true,
        page: 'orderSearchList',
        isScannedToday: status === 'scanned'
      });

      if (status === 'awaiting') {
        this.setState({ awaitingOrdersLoading: false });
      } else {
        this.setState({ scannedOrdersLoading: false });
      }
    }
  };

  render() {
    return (
      <>
        {/* {this.props.route.params.alert &&<AlertBoxSaving name={i18n.t('directprinting.printComplete')}  closeAlert ={ ()=>{this.closeAlert()}}/>} */}
        <View
          style={{flex: 1, zIndex: '99'}}
          testID="closeTooltip"
          onStartShouldSetResponder={() => {
            this.drawerClose(),
              this.state.toolTipCheck ? this.tooltipFun() : <></>;
            this.state.refreshToolTip ? this.refreshTooltipFun() : <></>;
          }}>

          { this.props.cartInProgress && (<ResumePickingPrompt />) }
          { this.props.showCartAssignmentToast && (<AssignmentToast onRunImport={this.importorderFun}/>)}
          { this.props.showCartAssignmentDetailsPrompt && (<CartAssignmentDetails />)}

          { this.props.zoneAccessModalForCart?.visible && this.props.zoneAccessModalForCart.cartId != null && (
            <CartOptionalZoneAccessModal
              isVisible={true}
              onClose={() => this.props.setZoneAccessModalForCart({ visible: false })}
              cartId={this.props.zoneAccessModalForCart.cartId}
              cartName={this.props.zoneAccessModalForCart.cartName}
              scanBarcodePayload={this.props.zoneAccessModalForCart.scanBarcodePayload}
            />
          )}

          <Toast
            visible={this.props.showDuplicatePickToast}
            message={i18n.t('duplicatePickWarning.activityLogAdded')}
            onHide={() => this.props.hideDuplicatePickToast()}
          />

          <ShipmentSelectionModal
            visible={this.state.showShipmentSelection}
            order={this.state.currentOrderData}
            shipments={this.state.currentShipments}
            onSelectShipment={this.handleShipmentSelection}
            onClose={this.closeShipmentSelection}
          />
          { this.props.showCartAssignmentDetailsPrompt && (<CartAssignmentDetails />)}



          <DuplicatePickWarningModal
            visible={this.props.showDuplicatePickWarning}
            onClose={this.handleCloseDuplicatePickWarning}
            onContinue={this.handleContinueDuplicatePick}
            onReport={this.handleReportDuplicatePick}
            onSilenceNotifications={this.handleSilenceNotifications}
          />

          {
            // Notification Pop Up for messages
            (this.state.popUpModelShow || this.props.showNotification) && (
              <PopUpModel
                closeAlert={this.closeAlert.bind(this)}
                message={this.state.message}
                messageTypeSuccess={
                  this.state.messageTypeSuccess ? true : false
                }
              />
            )
          }

          {this.state.onDemandCountdown !== null && (
            <OnDemandCountdown
              message={this.state.onDemandMessage}
              seconds={this.state.onDemandCountdown}
              onCancel={this.cancelOnDemandCountdown}
            />
          )}

          {this.state.reScanPopupCond && !this.props?.isLoadingActive ? (
            <RescanPopup
              headingmessage={i18n.t("scanPack.alreadyScanned")}
              subHeading={i18n.t("scanPack.howToProceed")}
              cancelButton="Cancel"
              rePrintBtn={i18n.t("scanPack.rePrint")}
              reScanBtn={i18n.t("scanPack.reScan")}
              closePopup={this.closePopup.bind(this)}
              redirectToAnother={this.redirectToAnother.bind(this)}
              reScanOrderPopupShow={this.state.reScanOrderPopupShow}
              reScanPopupShow={this.state.reScanPopupShow}
              closePopupRescan={this.closePopupRescan.bind(this)}
              awaitOrderDataFun={parameter => this.awaitOrderDataFun(parameter)}
              newProps={this.props}
              navigation={this.props?.navigation}
              basicInfo={this.props?.searchOrder?.searchOrder?.data?.order?.[0]}
              generalSetting={this.props?.ordersList?.general_settings}
              userRole={this.props?.userInfo}
              newState={this.state.reScanPopupCond}
              isLoadingHere={this.props?.isLoadingActive}
              ssLabelData={this.props?.ssLabelData}
            />
          ) : (
            <></>
          )}
          {this.state.popInternet === false ? (
            <View style={{position: 'absolute', zIndex: 99, top: '-10%'}}>
              <InerternetConnectionAlert message={i18n.t('session.connectionRestore')}/>
            </View>
          ) : null}
          <ImageBackground
            style={{flex: 1}}
            source={require('././../../../assets/background.png')}>
            {/* <View onStartShouldSetResponder={() => this.nav()}> */}
            <ScrollView
              contentContainerStyle={{flex: 1}}
              style={{position: 'relative'}}>
              <ImageBackground
                style={CommonStyles.quickScanImage}
                source={require('././../../../assets/scaning.png')}
                resizeMode="contain">
                <Text
                  style={[
                    CommonStyles.ScanText,
                    {lineHeight: this.state.windowwidth < 768 ? 55 : 90}
                  ]}>
                  {i18n.t("scanPack.scanLabel")}
                </Text>
                <Text style={[CommonStyles.lastImportTextOne, {marginTop: 0}]}>
                  {this?.state?.cueOrderStatus}
                </Text>

                <View
                  style={[
                    CommonStyles.searchContainer,
                    {width: this.state.windowwidth > 900 ? '30%' : '95%'}
                  ]}>
                  <ScanTextInput
                    testID="searchOrder"
                    name="searchOrder"
                    autoFocus={!this.props.cameraHook.showCameraScanner}
                    editable={this.state.manageApiStatus}
                    dataSet={{componentName: 'searchOrder'}}
                    placeholder={i18n.t('scanPack.inputPlaceHolder')}
                    ref={this.inputFocus}
                    value={
                      this.state.showQuick ? 'QUICKSCAN' : this.state.data.input
                    }
                    onChangeText={text => {
                      this.handleChange('searchOrder', text);
                    }}
                    // onSubmitEditing={() => {
                    //   debugger
                    //   if (this.state.data.input === '') return;
                    //   this.searchOrder(
                    //     this.state.data && this.state.data.input
                    //   );
                    // }}
                    onKeyPress={e => {
                      if (e.key === 'Enter') {
                        if (this.state.data.input === '') return;
                        this.searchOrder(
                          this.state.data && this.state.data.input
                        );
                      }
                    }}
                    style={CommonStyles.scanInput}
                  />
                  {this.props.cameraHook.camScannerEnabled && (
                    <TouchableOpacity
                      testID="cameraScanBtn"
                      style={{ paddingVertical: 4, paddingHorizontal: 5 }}
                      onPress={this.openCameraScanner}>
                      <Ionicons
                        name="camera"
                        size={23}
                        color="rgb(172,187,199)"
                      />
                    </TouchableOpacity>
                  )}
                  <TouchableOpacity
                    testID="rfoSearchBtn"
                    style={{ paddingVertical: 4, paddingHorizontal: 5 }}
                    onPress={() => {
                      if (this.state.data.input === '') {
                        this.handleOrderImport();
                        return;
                      }
                      this.searchOrder(
                        this.state.data && this.state.data.input
                      );
                    }}>
                    <i
                      className="icon-search"
                      style={{
                        color: 'rgb(172,187,199)',
                        fontSize: '23px'
                      }}></i>
                  </TouchableOpacity>
                </View>

                {/* Inline Camera Scanner - appears below TextInput */}
                {this.props.cameraHook.showCameraScanner && (
                  <View style={{
                    width: this.state.windowwidth > 900 ? '30%' : this.state.windowwidth > 600 ? '60%' : '95%',
                    alignSelf: 'center', marginTop: 20
                  }}>
                    <CamScanner
                      inline={true}
                      onScan={this.handleCameraScan}
                      onClose={this.handleCameraClose}
                    />
                  </View>
                )}

                {(this.state.newLoading || this.props.isLoadingActive) && (
                  <View
                    style={{
                      position: 'fixed',
                      left: 0,
                      right: 0,
                      height: '100%',
                      top: 0,
                      bottom: 0,
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#000',
                      opacity: '60%',
                      zIndex: 2147483647
                    }}>
                    <ActivityIndicator size="large" color="#fff" />
                    <Text
                      style={{
                        fontSize: 13,
                        fontWeight: 500,
                        textAlign: 'center',
                        color: '#fff'
                      }}>
                      Loading...
                    </Text>
                  </View>
                )}
                {this.state.loading ? (
                  <View style={{flex: 1, justifyContent: 'center'}}>
                    {/* Activity Indicator Shown  */}
                    <ActivityIndicator size="large" color="#336599" />
                  </View>
                ) : (
                  <>
                    {this.state.error ? (
                      <Text style={styles.text}>{this.state.error}</Text>
                    ) : null}
                  </>
                )}
                <View style={[CommonStyles.quickScanAlignmentOne, { display: !this.state.rfoTitle && 'none' }]}>
                  <LinearGradient
                    colors={['#95abbf', '#516b83']}
                    style={CommonStyles.quickScanRfo}>
                    <View />
                    <TouchableOpacity
                      testID="quickSearch"
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                      }}
                      dataSet={{componentName: 'quickSearch'}}
                      onPress={() => {
                        if (
                          this.state.rfoTitle &&
                          this.state.popInternet === true
                        ) {
                          this?.props?.userInfo?.role?.access_scanpack &&
                            this.searchOrder(this.state.rfoTitle);
                        }
                      }}>
                      <View style={{alignItems: 'center'}}>
                        <Text
                          testID="quickScan"
                          style={CommonStyles.quickScanText}>
                          {i18n.t("scanPack.quickScanLabel")}
                        </Text>
                        {!this.state.loading ? (
                          <Text style={CommonStyles.quickScanLoadingText}>
                            {this.state.rfoTitle
                              ? this.state.rfoTitle
                              : i18n.t("scanPack.noOrderPresent")}
                          </Text>
                        ) : null}
                      </View>
                      {/* <FontAwesome name="double-arrow" size={24} color="black" /> */}
                      {/* <FontAwesome name="double-arrow" size={28} color="rgb(119, 143, 165)" /> */}
                      <i
                        className="icon-right-circled"
                        style={{
                          fontSize: 24,
                          color: 'white',
                          marginTop: 12
                        }}></i>
                    </TouchableOpacity>
                  </LinearGradient>
                  <TouchableOpacity
                    testID="tooltipFun"
                    onPress={() => this.tooltipFun()}>
                    <i
                      className="icon-info-circled"
                      style={{
                        color: 'rgb(119,143,165)',
                        fontSize: '24px',
                        marginLeft: '10px'
                      }}></i>
                    {/* <FontAwesome name="info-circle" size={20} style={{ marginLeft: 10 }} color="rgb(119, 143, 165)" /> */}
                    {/* <Image source={require('././../../../assets/notificationicon.png')} style={{ height: 15, width: 15, marginLeft: 10 }} /> */}
                  </TouchableOpacity>
                </View>
                {this.state.quickScanToolTip && (
                  <LinearGradient
                    testID="quickScanToolTip"
                    locations={[0, 1]}
                    colors={['#8a9daf', '#d7e1e9']}
                    style={CommonStyles.quickScanTooltipContainer}>
                    <Text style={CommonStyles.quickScanTextOne}>
                      {i18n.t("scanPack.quickScanTollTip")}
                    </Text>
                    <View style={CommonStyles.quickScanTooltipContainerOne} />
                  </LinearGradient>
                )}
                <AssignOrdersButton
                  setFocus={value => {
                    isToFocus = value;
                  }}
                  getOrder={this.getOldestUnscannedOrder}
                />
                <OptionalZoneAccessButtons
                  username={this.props.userInfo?.username}
                  maxWidth={
                    this.state.windowwidth > 0
                      ? this.state.windowwidth * (this.state.windowwidth > 900 ? 0.3 : 0.95)
                      : undefined
                  }
                />
                <CartAssignmentPrompt 
                  showPrompt={this.state.showCartAssignmentPrompt}
                  setShowPrompt={value=>this.setState({showCartAssignmentPrompt: value})}
                  cartId={this.state.cartId}
                  payload={this.state.data}
                />
                {this.props.importOrder.importstatusData?.summary?.import_info
                  ?.status == 'cancelled' ? (
                  <View style={{marginTop: 50}}>
                    <Text style={CommonStyles.lastImportText}>
                      {/* Import  Is {String(this.props?.importOrder?.time)} */}
                      {this.state.importOrderText}
                      {/* {moment(this.props.importOrder.importstatusData?.summary?.import_info?.updated_at).format('MMMM Do YYYY, h:mm:ss a')} */}
                    </Text>
                  </View>
                ) : this.props.importOrder.importstatusData?.summary
                    ?.import_info?.status == 'completed' ? (
                  <View
                    style={{marginTop: this.state.windowwidth < 768 ? 10 : 50}}>
                    <Text
                      style={[
                        CommonStyles.lastImportText,
                        {marginBottom: this.state.windowwidth < 768 && -30}
                      ]}>
                      {/* Import  Is {String(this.props?.importOrder?.time)} */}
                      {this.state.importOrderText}
                      {/* {this.props.importOrder.importstatusData?.summary?.import_info?.updated_at} */}
                    </Text>
                  </View>
                ) : // this.props.importOrder.importstatusData?.summary?.import_info?.status == "Import is in progress" ?
                // (<View style={{ marginTop: 50 }}>
                //   <Text style={{ color: '#8da4b8', fontFamily: fontFamily.font300, marginBottom: 7, fontSize: 16 }}>
                //     {/* Import  Is {String(this.props?.importOrder?.time)} */}
                //     Last import {this.state.importOrderText}
                //     {/* {this.props.importOrder.importstatusData?.summary?.import_info?.updated_at} */}
                //   </Text>
                // </View>)
                // :
                this.props?.importOrder?.importstatusData?.summary?.import_info
                    ?.status == 'not_started' ? (
                  <View style={CommonStyles.quickScanAlignment}>
                    <Text style={CommonStyles.lastImportText}>
                      {/* Import  Is {String(this.props?.importOrder?.time)} */}
                      {this.state.importOrderText}
                      {/* {this.props.importOrder.importstatusData?.summary?.import_info?.updated_at} */}
                    </Text>
                    {this?.state?.ShowEtaText && (
                      <Text style={CommonStyles.lastImportText}>
                        {/* Import  Is {String(this.props?.importOrder?.time)} */}
                        {this.state.EtaText}
                        {/* {this.props.importOrder.importstatusData?.summary?.import_info?.updated_at} */}
                      </Text>
                    )}
                  </View>
                ) : this.props?.importOrder?.importstatusData?.summary
                    ?.import_info?.status == 'in_progress' ? (
                  <View style={CommonStyles.quickScanAlignment}>
                    <Text style={CommonStyles.lastImportText}>
                      {/* Import  Is {String(this.props?.importOrder?.time)} */}
                      {this.state.importOrderText}
                      {/* {this.props.importOrder.importstatusData?.summary?.import_info?.updated_at} */}
                    </Text>
                    {this?.state?.ShowEtaText && (
                      <Text style={CommonStyles.lastImportText}>
                        {/* Import  Is {String(this.props?.importOrder?.time)} */}
                        {this.state.EtaText}
                        {/* {this.props.importOrder.importstatusData?.summary?.import_info?.updated_at} */}
                      </Text>
                    )}
                  </View>
                ) : (
                  <View></View>
                )}
                <View
                  style={[CommonStyles.importButtonRfo, {alignSelf: 'center'}]}>
                  {this?.state?.importButton && (
                    <TouchableOpacity
                      dataSet={{componentName: 'importButton'}}
                      onPress={this.handleOrderImport}>
                      <LinearGradient
                        colors={['#95abbf', '#516b83']}
                        style={[CommonStyles.quickScanContainer2]}>
                        <Text style={[CommonStyles.reFreshText, {width: 69}]}>
                          Import Now
                        </Text>
                        <View style={{width: 4, height: 21}} />
                        <i
                          className="icon-down-circled"
                          style={{
                            fontSize: 24,
                            color: 'white',
                            marginTop: 2
                          }}></i>
                      </LinearGradient>
                    </TouchableOpacity>
                  )}
                  {this.props?.importOrder?.importdata?.error_messages &&
                    this.state.animatingType !== false && (
                      <View style={{marginTop: 20}}>
                        <ActivityIndicator
                          size="large"
                          color="#95abbf"
                          animating={this.state.animatingType}
                        />
                      </View>
                    )}
                  <TouchableOpacity
                    dataSet={{componentName: 'refreshButton'}}
                    onPress={() =>
                      this?.props?.userInfo?.role?.import_orders &&
                      this.state.popInternet === true ? (
                        this.refreshStatus()
                      ) : (
                        <></>
                      )
                    }>
                    <LinearGradient
                      colors={['#95abbf', '#516b83']}
                      style={[CommonStyles.quickScanContainer2, {width: 93}]}>
                      <Text style={CommonStyles.reFreshText}>Refresh</Text>
                      <View style={{width: 4, height: 21}} />
                      <i
                        className="icon-arrows-cw"
                        style={{
                          fontSize: 24,
                          color: 'white',
                          marginTop: 2
                        }}></i>
                    </LinearGradient>
                  </TouchableOpacity>
                  <TouchableOpacity
                    testID="refreshTooltipFun"
                    onPress={() => this.refreshTooltipFun()}>
                    <i
                      className="icon-info-circled"
                      style={{
                        color: 'rgb(119,143,165)',
                        fontSize: '24px',
                        marginTop: '35px',
                        position: 'absolute'
                      }}></i>
                    {this.state.refreshToolTip && (
                      <LinearGradient
                        testID="refreshToolTip"
                        locations={[0, 1]}
                        colors={['#8a9daf', '#d7e1e9']}
                        style={CommonStyles.refreshTextTooltip}>
                        <Text style={CommonStyles.quickScanTextOne}>
                          {i18n.t('scanpackItem.refreshTooltip')}
                        </Text>
                        <View style={CommonStyles.refreshTooltipContainerOne} />
                      </LinearGradient>
                    )}
                  </TouchableOpacity>
                </View>
                <View style={{height: 40, width: '100%'}} />
                {/* Awaiting Orders Count Display */}
                <View style={styles.ordersCountContainer}>
                  {this.state.awaitingOrdersCount >= 0 && (this.state.list || this.state.orderDetail) && (
                    <TouchableOpacity
                      style={styles.orderCountBox}
                      onPress={() => this.navigateToOrders('awaiting')}
                      testID="awaitingOrdersBox"
                      disabled={this.state.awaitingOrdersLoading}
                    >
                      {this.state.awaitingOrdersLoading ? (
                        <ActivityIndicator size="large" color="#4ECDC4" />
                      ) : (
                        <>
                          <GradientText
                            text={String(this.state.awaitingOrdersCount)}
                            colors={['#253c57', '#00dfb7', '#5C778F']}
                            locations={[0.11, 0.46, 0.82]}
                            style={styles.orderCountNumber}
                            start={{x: 0, y: 1}}
                            end={{x: 1, y: 0}}
                          />
                          <Text style={styles.orderCountLabel}>Awaiting</Text>
                          <Text style={styles.orderCountLabel}>Orders</Text>
                        </>
                      )}
                    </TouchableOpacity>
                  )}
                  {this.state.scannedOrdersCount >= 0 && (this.state.list || this.state.orderDetail) && (
                    <TouchableOpacity
                      style={styles.orderCountBox}
                      onPress={() => {
                        this.navigateToOrders('scanned');
                      }}
                      testID="scannedOrdersBox"
                      disabled={this.state.scannedOrdersLoading}
                    >
                      {this.state.scannedOrdersLoading ? (
                        <ActivityIndicator size="large" color="#07bae5" />
                      ) : (
                        <>
                          <GradientText
                            text={String(this.state.scannedOrdersCount)}
                            colors={['#5c778f', '#07bae5', '#253C57']}
                            locations={[0.11, 0.46, 0.82]}
                            style={styles.orderCountNumber}
                            start={{x: 0, y: 1}}
                            end={{x: 1, y: 0}}
                          />
                          <Text style={styles.orderCountLabel}>Scanned</Text>
                          <Text style={styles.orderCountLabel}>Today</Text>
                        </>
                      )}
                    </TouchableOpacity>
                  )}
                </View>
              </ImageBackground>
            </ScrollView>
          </ImageBackground>
        </View>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    ssLabelData: state.order.ssLabelData,
    isLoadingActive: state?.order?.isLoadingActive,
    ordersList: state.order.list,
    searchOrder: state.scanpack,
    userInfo: state.user.userInfo,
    importOrder: state.importOrder,
    showNotification: state.menu.showNotification,
    isCodeFound: state.menu.isCodeFound,
    isOpen: state.menu.isOpen,
    bothSettings: state.user.bothSettings,
    purchaseLoading: state.order.purchaseLoading,
    orderList: state.saveLog,
    scanPackWorkflow: state.user.settings?.data?.scan_pack_workflow,
    scanToCartOption:
      state.user.bothSettings?.data?.data?.scanpack_setting
        ?.scan_to_cart_option,
    checkOrderStatus: state.scanpack.checkOrderStatus,
    cartInProgress: state.scanToCart.hasActivePickingSession,
    showCartAssignmentToast: state.scanToCart.showCartAssignmentToast,
    showCartAssignmentDetailsPrompt: state.scanToCart.showCartAssignmentDetailsPrompt,
    zoneAccessModalForCart: state.scanToCart.zoneAccessModalForCart,
    awaitingCountFromImport: state.scanpack.awaitingCountFromImport,
    isImportActive: state.scanpack.isImportActive,
    showDuplicatePickWarning: state.scanpack.showDuplicatePickWarning,
    duplicatePickWarningData: state.scanpack.duplicatePickWarningData,
    showDuplicatePickToast: state.scanpack.showDuplicatePickToast,
    onDemandImport: state.scanpack.onDemandImport,
  };
};

const mapDispatchToProps = {
  GetOrderList,
  SearchScanpackOrder,
  ShowNotification,
  UserInfo,
  ImportOrder,
  ImportOrderStatus,
  UpdateOrderStatus,
  ResetSearchOrderData,
  GetBothSettings,
  fetchUser,
  GetGeneralSetting,
  // ResetOrderList,
  ResetSearchOrderData,
  CheckImportOrderProcess,
  SubmitLog,
  getCartInProgress,
  hideDuplicatePickWarning,
  hideDuplicatePickToast,
  clearOnDemandImportEvent,
  setZoneAccessModalForCart,
  SetCameraOpen, // Still needed for handleScreenReturn
};
export default connect(mapStateToProps, mapDispatchToProps)(withCameraScanner('scanpack')(ScanPack));
